import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { HttpClient } from "@angular/common/http";
import { ProjectsService } from "../../services/projects/projects.service";
import swal from "sweetalert2";
import { Observable, Subscription } from "rxjs";
import { UserServiceService } from "../../services/user-service/user-service.service";

@Component({
  selector: "app-eta-taxes-listing",
  templateUrl: "./eta-taxes-listing.component.html",
  styleUrls: ["./eta-taxes-listing.component.scss"],
})
export class EtaTaxesListingComponent implements OnInit {
  active_tab: any = "filter";
  page = 1;
  pagination: any = [];
  totalRec: number;
  eta: Array<any> = [];
  inreservations = null;
  reservationRow: any;
  filesForm: FormGroup;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));

  current_page: any;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;

  installmentDays: any = [5, 10, 15, 20, 25, 28];
  is_refreshing = false;
  doc_type_installment_modal: any = ["PDF", "Excel"];
  is_installment_modal_loading = false;
  payments_option = ["Quarter", "Semi-annual", "Annual"];
  commentReservation: any;
  signature_date: any;
  selling_price: any;
  per_page: any;
  total: any;
  pageTest: any = 1;
  eta_raw_data: any;
  last_page_url: any;

  developers;

  eta_active_tab = "";

  current_eta;
  reason;

  etaSub$: Subscription;

  constructor(
    private router: Router,
    public fb: FormBuilder,
    public slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    public leadsService: LeadsService,
    private http: HttpClient,
    public projectService: ProjectsService,
    private userService: UserServiceService
  ) {
    if (!this.canAccessEta()) {
      swal(
        "Insufficient Permissions!",
        "You do not have permission to access this page",
        "error"
      );
      this.router.navigate(["/pages/dashboard"]);
    }
  }

  canAccessEta() {
    return (
      this.userProfile.role == "Admin" ||
      this.userProfile.role == "A.R Accountant" ||
      this.userProfile.role == "Treasury Accountant" ||
      this.userProfile.is_tax_account ||
      this.userProfile.is_eta_user
    );
  }

  ngOnInit() {
    this.createForm();
    this.getdevelopers();
  }

  getdevelopers() {
    this.slimLoadingBarService.start();
    this.userService.getDevelopers().subscribe(
      (data: any) => {
        this.developers = data;
        //console.log(this.developers);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  get issuer_id() {
    return this.filterForm.value.issuer_id;
  }

  getETAInvoices() {
    const issuer_id = this.filterForm.value.issuer_id;
    if (!issuer_id) return;
    const formData = this.filterForm.value;
    formData.direction = this.eta_active_tab;
    this.eta = null;
    this.slimLoadingBarService.start();
    this.is_refreshing = true;
    if (this.etaSub$) this.etaSub$.unsubscribe();
    this.etaSub$ = this.leadsService.getETAInvoices(formData).subscribe(
      (res: any) => {
        const data = {
          data: res,
          last_page_url: 1,
          total: 1,
          to: 1,
          last_page: 10,
        };
        this.eta_raw_data = data;
        this.pagination = [];
        this.last_page_url = data.last_page_url;
        this.current_page = 1;
        this.per_page = data.to;
        this.total = data.total;
        let selected = true;
        for (var i = 1; i <= data.last_page; i++) {
          if (i > 1) selected = false;
          this.pagination.push({ number: i, selected: selected });
        }
        this.totalRec = data.total;
        this.eta = data.data;
        this.slimLoadingBarService.complete();
        this.is_refreshing = false;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
        this.is_refreshing = false;
      },
      () => (this.is_refreshing = false)
    );
  }

  createForm() {
    this.filterForm = this.fb.group({
      issuer_id: [""],
      status: [""],
      date_from: [""],
      date_to: [""],
      registration_number: [""],
    });
  }

  filterETAInvoices() {
    this.pageTest = 1;
    const formModel = Object.assign(
      {},
      { ...this.filterForm.value, direction: this.eta_active_tab }
    );
    this.slimLoadingBarService.start();
    this.filterActive = true;
    this.filterData = formModel;
    // this.is_refreshing = true;
    if (this.etaSub$) this.etaSub$.unsubscribe();
    this.etaSub$ = this.leadsService.getETAInvoices(formModel).subscribe(
      (res: any) => {
        const data = {
          data: res,
          last_page_url: 1,
          total: 1,
          to: 1,
          last_page: 10,
        };
        let selected = true;
        this.eta_raw_data = data;
        this.pagination = [];
        this.last_page_url = data.last_page_url;
        this.current_page = 1;
        this.totalRec = data.total;
        this.eta = data.data;
        this.per_page = data.to;
        this.total = data.total;
        for (var i = 1; i <= data.last_page; i++) {
          if (i > 1) selected = false;
          this.pagination.push({ number: i, selected: selected });
        }
        // this.is_refreshing = false;
        //console.log(this.eta);
      },
      (err) => {
        this.slimLoadingBarService.reset();
        // this.errorHandlerService.handleErorr(err);
        //console.log(err);
        //console.log(err.error && err.status === 400);
        if (err.error && err.status === 400) {
          this.errorHandlerService.handleErorr(err);
        }
        this.slimLoadingBarService.reset();
      }
    );
  }

  resetFilters() {
    this.filterActive = false;
    this.filterData = null;
    const issuer_id = this.filterForm.value.issuer_id;
    this.createForm();
    this.filterForm.patchValue({ issuer_id: issuer_id });
    this.getETAInvoices();
  }

  infinite(url, number) {
    this.slimLoadingBarService.start();
    this.is_refreshing = true;
    if (this.etaSub$) this.etaSub$.unsubscribe();
    this.etaSub$ = this.leadsService.infinit(url).subscribe(
      (data: any) => {
        this.eta_raw_data = data;
        this.totalRec = data.total;
        this.eta = data.data;
        this.current_page = number;
        this.per_page = data.to;
        this.total = data.total;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      },
      () => (this.is_refreshing = false)
    );
  }

  infiniteWithFilter(url, number) {
    this.slimLoadingBarService.start();
    this.is_refreshing = true;
    if (this.etaSub$) this.etaSub$.unsubscribe();
    this.etaSub$ = this.leadsService
      .infinitWithPagination(url, this.filterData)
      .subscribe(
        (data: any) => {
          this.eta_raw_data = data;
          this.totalRec = data.total;
          this.eta = data.data;
          this.current_page = number;
          this.per_page = data.to;
          this.total = data.total;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        },
        () => (this.is_refreshing = false)
      );
  }

  pageChange(event) {
    let arr = this.last_page_url.split("?");
    let selectedUrl = `${arr[0]}?page=${event}`;
    if (this.filterActive) {
      this.infiniteWithFilter(selectedUrl, event);
    } else {
      this.infinite(selectedUrl, event);
    }
  }

  setFilterActiveTab() {
    if (this.active_tab == "" || this.active_tab == "sales-status") {
      this.active_tab = "filter";
    } else {
      this.active_tab = "";
    }
  }

  printETAInovice(invoice_id, issuer_id) {
    this.slimLoadingBarService.start();
    this.leadsService.printETAInovice(invoice_id, this.issuer_id).subscribe(
      (response: any) => {
        const blob = new Blob([response], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "file.pdf"; // default filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        swal(
          "ETA Invoice Downloaded, you can find the file in your downloads folder",
          "",
          "success"
        );
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getPendingETA() {
    const formModel = Object.assign({}, this.filterForm.value);
    const payload = {
      issuer_id: formModel.issuer_id,
    };
    this.slimLoadingBarService.start();
    if (this.etaSub$) this.etaSub$.unsubscribe();
    this.etaSub$ = this.leadsService.getPendingETA(payload).subscribe(
      (res: any) => {
        this.eta = res.map((eta) => {
          return {
            ...eta,
            issuerName: eta.issuer.name,
            internalId: eta.invoice_internal_id,
            receiverName: eta.rece,
            dateTimeIssued: eta.invoice_datetime,
            totalSales: eta.sales_amount,
            totalDiscount: "",
            total: eta.total_amount,
          };
        });
        //console.log(this.eta);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  setETAActiveTab(tab) {
    this.eta = [];
    this.eta_active_tab = tab;
    if (tab == "pending") {
      this.getPendingETA();
      return;
    }
    this.getETAInvoices();
  }

  openRejectETAModal(eta, modal) {
    this.current_eta = eta;
    modal.open();
  }

  submitRejectETAInvoice(modal) {
    swal({
      title: "Are you sure?",
      text: "You will reject this ETA Invoice!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        const payload = {
          reason: this.reason,
        };
        this.slimLoadingBarService.start();
        this.leadsService
          .rejectETAInvoice(this.current_eta.uuid, payload)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              swal("Woohoo!", "Rejected ETA Invoice successfully!", "success");
              modal.close();
              this.getETAInvoices();
              this.reason = null;
            },
            (err) => {
              //console.log(err);
              if (err.error && err.error.message) {
                swal("error", err.error.message, "error");
              }
              this.slimLoadingBarService.reset();
            }
          );
      }
    });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case "Invalid":
        return "bg-invalid";
      case "Valid":
        return "bg-valid";
      case "Cancelled":
        return "bg-cancelled";
      case "Rejected":
        return "bg-rejected";
      case "pending":
        return "bg-pending";
      default:
        return "";
    }
  }

  onIssuerChange() {
    //console.log(this.eta_active_tab);
    if (this.eta_active_tab == "pending") {
      this.getPendingETA();
    } else {
      this.getETAInvoices();
    }
  }

  goToEditETA(invoice) {
    //console.log(invoice);
    this.router.navigate([`/pages/financial/eta-taxes/${invoice.uuid}/edit`]);
  }

  goToCreditNotes(invoice) {
    //console.log(invoice);
    const url = `/pages/financial/eta-taxes/${invoice.uuid}/edit?mode=credit-notes&issuer_id=${this.issuer_id}`;
    //console.log(url);
    this.router.navigateByUrl(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/eta-taxes-listing/eta-taxes-listing.component.ts